// src/data/listingTypes.js
// Types d'annonces par catégorie - NE PAS MODIFIER

export const LISTING_TYPES = {
    sejours: [
      { id: 'hotel', name: 'Hôtel' },
      { id: 'hostel', name: 'Auberge' },
      { id: 'studio', name: 'Studio meublé' },
      { id: 'room', name: 'Chambre' },
      { id: 'apartment', name: 'Appartement meublé' },
      { id: 'villa', name: 'Villa' },
      { id: 'guesthouse', name: 'Maison d\'hôte' },
      { id: 'airbnb', name: 'Logement entier' },
    ],
    locations: [
      { id: 'studio', name: 'Studio' },
      { id: 'apartment1', name: 'Appartement 1 chambre' },
      { id: 'apartment2', name: 'Appartement 2 chambres' },
      { id: 'apartment3', name: 'Appartement 3 chambres' },
      { id: 'apartment4plus', name: 'Appartement 4+ chambres' },
      { id: 'house1', name: 'Maison 1 chambre' },
      { id: 'house2', name: 'Maison 2 chambres' },
      { id: 'house3', name: 'Maison 3 chambres' },
      { id: 'house4plus', name: 'Maison 4+ chambres' },
      { id: 'duplex', name: 'Duplex' },
      { id: 'villa', name: 'Villa' },
      { id: 'warehouse', name: 'Entrepôt' },
    ],
    immobilier: [
      { id: 'terrain', name: 'Terrain' },
      { id: 'parcelle', name: 'Parcelle viabilisée' },
      { id: 'plot', name: 'Parcelle clôturée' },
      { id: 'agricultural', name: 'Terrain agricole' },
      { id: 'commercial', name: 'Terrain commercial' },
      { id: 'industrial', name: 'Terrain industriel' },
      { id: 'house', name: 'Maison' },
      { id: 'villa', name: 'Villa' },
      { id: 'apartment', name: 'Immeuble appartements' },
      { id: 'building', name: 'Bâtiment commercial' },
      { id: 'shop', name: 'Commerce/Boutique' },
    ],
    services: [
      { id: 'cleaning', name: 'Nettoyage' },
      { id: 'moving', name: 'Déménagement' },
      { id: 'renovation', name: 'Rénovation' },
      { id: 'plumbing', name: 'Plomberie' },
      { id: 'electrical', name: 'Électricité' },
      { id: 'painting', name: 'Peinture' },
      { id: 'security', name: 'Sécurité' },
      { id: 'gardening', name: 'Jardinage' },
      { id: 'maintenance', name: 'Entretien' },
      { id: 'delivery', name: 'Livraison' },
    ],
  };
  
  // Index pour recherche rapide par catégorie
  export const TYPES_MAP = Object.keys(LISTING_TYPES).reduce((acc, category) => {
    acc[category] = LISTING_TYPES[category].reduce((typeAcc, type) => {
      typeAcc[type.id] = type;
      return typeAcc;
    }, {});
    return acc;
  }, {});
  
  // Fonction pour obtenir les types d'une catégorie
  export const getTypesByCategory = (categoryId) => LISTING_TYPES[categoryId] || [];
  
  // Fonction pour obtenir le nom d'un type
  export const getTypeName = (categoryId, typeId) => {
    const type = TYPES_MAP[categoryId]?.[typeId];
    return type ? type.name : 'Type inconnu';
  };
  
  // Toutes les catégories avec leurs types
  export const CATEGORIES_WITH_TYPES = Object.keys(LISTING_TYPES).map((categoryId) => ({
    categoryId,
    types: LISTING_TYPES[categoryId],
  }));